// extracted by mini-css-extract-plugin
module.exports = {"hypnogram":"hypnogramStyle_hypnogram__XeXpI"};